import {
  IonContent,
  IonGrid,
  IonLabel,
  IonPage,
  IonRow,
  IonSpinner,
} from '@ionic/react';
import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { useLogout } from '../../api/auth.hooks';
import { useBeaconRouter } from '../../route/route.hooks';
import { sleep } from '../../util/async';
import './logout.css';

export const LogoutPage = (): ReactElement | null => {
  const { i18n } = useTranslation();
  const [isLoggedOut, setLoggedOut] = useState<boolean>(false);

  const { builder } = useBeaconRouter();
  const logout = useLogout();

  useEffect(() => {
    if (!isLoggedOut) {
      const performLogout = async () => {
        await logout();
        await sleep(200);
        setLoggedOut(true);
      };

      performLogout();
    }
  }, [logout, isLoggedOut]);

  if (isLoggedOut) {
    return (
      <Redirect
        to={{
          pathname: builder.getAuthLoginRoute(),
        }}
      />
    );
  }

  return (
    <IonPage>
      <IonContent>
        <IonGrid className="logout-page-container">
          <IonRow className="ion-justify-content-center ion-align-items-center">
            <IonLabel className="ion-padding-bottom">
              {i18n.t('common:logout_performing')}
            </IonLabel>
            <IonSpinner />
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
